import areaSelect from 'area-select';
import employee from 'Employee';
import {
    MAP_LIST
} from '$http';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';

export default {
    components: {
        'area-select': areaSelect,
        'employee': employee
    },
    props: {
        value: {
            type: Boolean
        }
    },
    data() {
        return {
            visiable: false,
            employeeVisiable: false,
            result: this.getInitResult(),
            areaInfo: this.getInitAreaInfo(),
            employee: {
                d_name: '', //选中的部门名称
                employeeName: '' //选中的员工名称
            },
            LeasingManager: {
                d_name: '', //选中的部门名称
                employeeName: '' //选中的员工名称
            },
            checkAll: false,
            choiceProjectList: [],
            intentProjectList: MAP_LIST.INTENT_PROJECT,
            checkedIntentProjects: [],
            isLeasingManager: false, //判断是不是招商经理
        };
    },
    computed: {
        customerLevelList() {
            return this.$store.state.customerLevelList;
        },
        customerSourceList() {
            return this.$store.state.customerSourceList;
        }
    },
    watch: {
        value(val) {
            this.visiable = val;
        },
        visiable(val) {
            this.$emit('input', val);
        }
    },
    methods: {
        getInitResult() {
            return cloneDeep({
                BusKeyWord: '',
                Customer: '', //公司
                Create_Date_Start: '', //创建时间开始
                Create_Date_End: '', //创建时间结束
                StartFollow: '', //最后跟进时间开始
                EndFollow: '', //最后跟进时间结束    
                Tel: '', //电话 
                DepartmentId: null, //部门Id
                Employee_Id: null, //员工Id
                LeasingManagerId: '', //所属招商经理
                CustomerLevel_Id: null, //意向级别
                CustomerSource_Id: null, //客户来源
                ProjectTypes: '',
                C_Name:""
            });
        },
        getInitAreaInfo() {
            return cloneDeep({
                Provinces_Id: null,
                City_Id: null,
                Area_Id: null
            });
        },
        getFormdata() {
            this.result.ProjectTypes = this.choiceProjectList.join(",");
            let formdata = Object.assign({}, this.areaInfo, this.result);
            Object.keys(formdata).forEach(key => {
                if (formdata[key] === '' || formdata[key] === null) {
                    delete formdata[key];
                }
            });
            return formdata;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.intetPorjectList.length;
        },
        search() {
            let filterData = this.getFormdata();
            this.$emit('search', filterData);
        },
        reset() {
            this.result = this.getInitResult();
            this.areaInfo = this.getInitAreaInfo();
            // this.$refs.areaForm.resetFields();
            this.choiceProjectList = [];
            this.employee = {
                d_name: '', //选中的部门名称
                employeeName: '' //选中的员工名称
            };
            this.LeasingManager = {
                d_name: '', //选中的部门名称
                employeeName: '' //选中的员工名称
            };
            this.$emit('reset');
        },
        showEmployee() {
            this.isLeasingManager = false
            this.employeeVisiable = true;

        },
        // 招商经理
        showEmployee2() {
            this.isLeasingManager = true
            this.employeeVisiable = true;

        },
        selectEmployee(data) {
            // this.result.DepartmentId = data.d_id;
            if (this.isLeasingManager) {
                this.result.LeasingManagerId = data.employeeId;
                this.LeasingManager.d_name = data.d_name;
                this.LeasingManager.employeeName = data.employeeName;
            } else {
                this.result.Employee_Id = data.employeeId;
                this.employee.d_name = data.d_name;
                this.employee.employeeName = data.employeeName;
            }


        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/complex-search/vm.js